import { Identified } from "@/types/sdk-types";
import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../hooks/use-encounter-creation-gate";
import { MedicalCodeControllerApi, MedicalCode } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface UseGetDataImportProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey: string;
  active?: boolean;
  archive?: boolean;
  enabled?: boolean;
}

/**
 * @author rajkumar rathod
 */
const useGetCptHcpcsCode = ({
  pagination,
  gridSorting,
  searchKey,
  active,
  archive,
  enabled = true,
}: UseGetDataImportProps): useBaseContent<Identified<MedicalCode>> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;
  const skip = useEncounterCreationGate();
  return useQuery({
    queryKey: [
      "catalog-cpt-hcpcs-code-import",
      pageSize,
      pageIndex,
      searchKey,
      gridSorting,
      active,
      archive,
    ],
    refetchOnWindowFocus: false,

    placeholderData: keepPreviousData,
    enabled: enabled && !skip,
    queryFn: async () =>
      new MedicalCodeControllerApi(getConfigObject())
        .getCptHcpcsMedicalCodes(
          pageIndex, //page number
          pageSize, //page size
          sortBy, //sortBy
          sortDirect, //sort
          active, //active
          archive, //archive
          undefined, //source
          searchKey, //searchString
          undefined //xTENANTID
        )
        .then((res) => res?.data),
  });
};

export default useGetCptHcpcsCode;
